import jwt_decode from 'jwt-decode';
import { getToken } from '../token';

/**
 * Роли системы.
 *
 * Раньше названия ролей были разбросаны строками по компонентам, и проверки писались
 * «от обратного»: `role !== 'Преподаватель'` открывало доступ. При добавлении новой роли
 * такая проверка молча выдаёт ей максимум прав, поэтому здесь только положительные списки:
 * доступ получает тот, кто явно перечислен.
 */
export const ROLES = {
  ADMIN: 'Администратор',
  EDITOR: 'Редактор',
  READER: 'Читатель',
  TEACHER: 'Преподаватель',
  JOURNAL_TEACHER: 'Преподаватель ЭЖ',
  UNAUTHORIZED: 'Unauthorized',
};

export const getUserRole = () => {
  const token = getToken();

  if (!token) return ROLES.UNAUTHORIZED;

  try {
    return jwt_decode(token).role;
  } catch (e) {
    return ROLES.UNAUTHORIZED;
  }
};

export const getUserId = () => {
  const token = getToken();

  if (!token) return null;

  try {
    return jwt_decode(token).userId;
  } catch (e) {
    return null;
  }
};

// Контингент: список слушателей, карточки, агенты, рассылки, отчёты.
const CONTINGENT_ROLES = [ROLES.ADMIN, ROLES.EDITOR, ROLES.READER];
const CONTINGENT_EDIT_ROLES = [ROLES.ADMIN, ROLES.EDITOR];

// Электронный журнал.
const JOURNAL_ROLES = [ROLES.ADMIN, ROLES.EDITOR, ROLES.READER, ROLES.JOURNAL_TEACHER];
const JOURNAL_MANAGE_ROLES = [ROLES.ADMIN, ROLES.EDITOR];

export const hasContingentAccess = (role = getUserRole()) => CONTINGENT_ROLES.includes(role);
export const canEditContingent = (role = getUserRole()) => CONTINGENT_EDIT_ROLES.includes(role);

export const hasJournalAccess = (role = getUserRole()) => JOURNAL_ROLES.includes(role);
export const canManageJournal = (role = getUserRole()) => JOURNAL_MANAGE_ROLES.includes(role);

export const isAdmin = (role = getUserRole()) => role === ROLES.ADMIN;
export const isReader = (role = getUserRole()) => role === ROLES.READER;
export const isTeacher = (role = getUserRole()) => role === ROLES.TEACHER;
export const isJournalTeacher = (role = getUserRole()) => role === ROLES.JOURNAL_TEACHER;

/**
 * Куда вести пользователя после входа и с несуществующего адреса.
 *
 * Раньше все шли на HOME_ROUTE — список контингента. У роли «Преподаватель ЭЖ» такого
 * маршрута нет, и её выбрасывало на /start, то есть войти было можно, а попасть некуда.
 */
export const landingRoute = (role = getUserRole()) => {
  if (hasContingentAccess(role) || isTeacher(role)) return '/';
  if (hasJournalAccess(role)) return '/journal';
  return '/start';
};
